import { PROSPECT_ENDPOINTS } from '../../../utils/api/endpoints/prospectEndpoints';
import { UseProspectsQueryParams, UseProspectsResponse } from './useProspects.types';

const PREFIX = '[prospectsQuery]';

export const queryAllProspects = async (params: UseProspectsQueryParams) => {
  console.log(PREFIX, `Fetching prospects...`);
  const response = await PROSPECT_ENDPOINTS.getAll(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received prospects.`);
  return json as UseProspectsResponse;
};
